import { DocumentacionPEXENTITY } from 'sigo-entities'
import { DtoTrabajosDE } from '../../../Lista/Domain/DtoTrabajosDE'
import { generarModeloDocZanja } from './Processes'

class UseCaseProcessesDoc {

  generarModeloDocZanja(documentacion: DocumentacionPEXENTITY, trabajo: DtoTrabajosDE) { return generarModeloDocZanja(documentacion, trabajo) }

}

export const UseCaseProcesses = new UseCaseProcessesDoc()